<template>
<nav aria-label="Page navigation" class="page-nav">
  <ul class="pagination justify-content-center">
    <li class="page-item" :class="prevStyle">
      <a class="page-link" href="#" aria-label="Previous" @click.prevent="onPageSelected(current-1)">
        <span aria-hidden="true">&laquo;</span>
        <span class="sr-only">Previous</span>
      </a>
    </li>
    <li v-for="p in max"
     class="page-item" :class="p === current ? 'disabled' : ''"
     @click.prevent="onPageSelected(p)"
     >
      <a class="page-link" href="#">{{ p }}</a>
    </li>
    <li class="page-item" :class="nextStyle">
      <a class="page-link" href="#" @click.prevent="onPageSelected(current+1)">
        <span aria-hidden="true">&raquo;</span>
        <span class="sr-only">Next</span>
      </a>
    </li>
  </ul>
</nav>
</template>

<script>
export default {
  props: ['current', 'max'],
  computed: {
    prevStyle () {
      return this.current === 1 ? 'disabled' : ''
    },
    nextStyle () {
      return this.current === this.max ? 'disabled' : ''
    }
  },
  methods: {
    onPageSelected (page) {
      if (page === this.current) {
        return
      }
      this.$emit('onPageSelected', page)
    }
  }
}
</script>



// WEBPACK FOOTER //
// PageNav.vue?f212629c